<template>

  <div style="height: 20em">
    <b-tabs content-class="mt-3 pl-2 pr-2">
      
      <b-tab title="Algemeen" active>
        <b-form-group id="input-group-1" label="Naam:" label-for="input-1">
          <b-form-input id="input-1" v-model="displayName" type="text" />
        </b-form-group>
        <b-form-group id="input-group-2" label="Interne naam:" label-for="input-2">
          <b-form-input id="input-2" v-model="internalName" type="text" />
        </b-form-group>
      </b-tab>
      
      <b-tab title="Firmware">
        <p>Huidige firmware versie: {{device.fwVer}}</p>
        <b-overlay :show="device.status !== 'ONLINE'" variant="secondary" rounded>
          <b-form-group label="Nieuwe versie:">
            <b-input-group>
              <b-select :options="firmwares.nodes" v-model="newFirmware">
                <template #first>
                  <b-form-select-option :value="null" disabled>-- Kies een optie --</b-form-select-option>
                </template>
              </b-select>
              <busy-btn variant="warning" class="ml-2" :busy="fwBusy" @click="installFw">Installeer</busy-btn>
            </b-input-group>
          </b-form-group>
          <template #overlay>
            <div class="text-center">Toestel moet online zijn om nieuwe firmware te installeren</div>
          </template>
        </b-overlay>
      </b-tab>
      
    </b-tabs>
  </div>

</template>

<script>

import BusyBtn from '@/components/BusyBtn';
import {CACHE_AND_NETWORK, NETWORK_ONLY} from '@/lib/constants';

export default
{
    apollo:
    {
        firmwares:
        {
            fetchPolicy: CACHE_AND_NETWORK,
            query: require('../graphql/query/firmwares.gql'),
        },
        $subscribe:
        {
            fwVer:
            {
                query: require('../graphql/live/device_fw_version.gql'),
                variables() { return { id: this.id } },
                result({data: { deviceById } })
                {
                    this.device = deviceById;
                }
            }
        }
    },
    components: { BusyBtn },
    async mounted()
    {
        const { data: { deviceById } } = await this.$apollo.query(
            {
                query: require('../graphql/query/for_edit_device.gql'),
                variables: { id: this.id },
                fetchPolicy: NETWORK_ONLY
            }
        );

        this.displayName = deviceById.displayName;
        this.internalName = deviceById.internalName;
    },
    data()
    {
        return {
            // Edit fields
            displayName: '',
            internalName: '',
            // End of edit fields
            firmwares: { nodes: [] },
            device: {},
            newFirmware: null,
            fwBusy: false
        }
    },
    methods:
    {
        async save(ok)
        {
            await this.$apollo.mutate(
                {
                    mutation: require('../graphql/mutation/edit_device.gql'),
                    variables:
                    {
                        id: this.id,
                        patch:
                        {
                            displayName: this.displayName,
                            internalName: this.internalName
                        }
                    }
                }
            );

            ok();
        },
        async installFw()
        {
            try
            {
                this.fwBusy = true;
                await this.$apollo.mutate(
                    {
                        mutation: require('../graphql/mutation/fw.gql'),
                        variables:
                        {
                            device: this.id,
                            firmware: this.newFirmware
                        }
                    }
                );
                await this.$bvModal.msgBoxOk(
                    'Installatie kan tot 10 minuten duren',
                    {
                        centered: true,
                        title: 'Aanvraag verzonden'
                    }
                );
            }
            finally
            {
                this.fwBusy = false;
            }
        }
    },
    props:
    {
        id: { type: String }
    }
}
</script>

<style>
</style>